export default class LevDist {
  constructor(answer) {
    this.answer = answer;
    this.response = "";
  }

  measureDistance(response, multiplier = 100, round = 0) {
    const s1 = response;
    const s2 = this.answer;

    let similarity_f;
    try {
      similarity_f =
        1 -
        this.fibGetLevenshteinDistance(s1, s2) / ((s1.length + s2.length) / 2);
    } catch (e) {
      similarity_f = 0.0;
    }

    if (similarity_f <= 0.02) {
      similarity_f = 0.0;
    }

    if (similarity_f >= 0.99) {
      similarity_f = 1.0;
    }

    similarity_f = Math.round(similarity_f * multiplier, round);

    return similarity_f;
  }

  fibGetLevenshteinDistance(a, b) {
    if (a.length === 0) return b.length;
    if (b.length === 0) return a.length;

    var matrix = [];

    // increment along the first column of each row
    var i;
    for (i = 0; i <= b.length; i++) {
      matrix[i] = [i];
    }

    // increment each column in the first row
    var j;
    for (j = 0; j <= a.length; j++) {
      matrix[0][j] = j;
    }

    // Fill in the rest of the matrix
    for (i = 1; i <= b.length; i++) {
      for (j = 1; j <= a.length; j++) {
        if (b.charAt(i - 1) === a.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1, // substitution
            Math.min(
              matrix[i][j - 1] + 1, // insertion
              matrix[i - 1][j] + 1
            )
          ); // deletion
        }
      }
    }

    return matrix[b.length][a.length];
  }
}
